import request from '@/utils/request'
import { objToUrlParams } from '@/utils'

// 获取首页数据
export const getDashboard = (params: any) =>
  request({
    url: '/manage/dashboard',
    method: 'get',
    params
  })

// 返佣排行榜
export const getRebateRank = (params: any) =>
  request({
    url: '/manage/rebate-rank',
    method: 'get',
    params
  })

// 余额排行榜
export const getBalanceRank = (params: any) =>
  request({
    url: '/manage/balance-rank',
    method: 'get',
    params
  })

// 折线图
export const getLineChart = (params: any) =>
  request({
    url: '/manage/line-chart',
    method: 'get',
    params
  })

// 饼图
export const getPieChart = (params: any) =>
  request({
    url: '/manage/pie-chart',
    method: 'get',
    params
  })

// 折线图
export const getBalanceLineChart = (params: any) =>
  request({
    url: '/manage/balance-line-chart',
    method: 'get',
    params
  })

// 商户可用余额排行榜
export const getMerchantBalanceRank = (params: any) =>
  request({
    url: '/manage/merchant-balance-rank',
    method: 'get',
    params
  })

// 入金排名
export const getMerchantDepositRank = (params: any) =>
  request({
    url: '/manage/merchant-deposit-rank',
    method: 'get',
    params
  })

// 出金排名
export const getMerchantWithdrawRank = (params: any) =>
  request({
    url: '/manage/merchant-withdraw-rank',
    method: 'get',
    params
  })

// 商户余额
export const getMerchantBalance = (params: any) =>
  request({
    url: '/manage/merchant-balance',
    method: 'get',
    params
  })

// 入金排名导出接口
export const getDepositRankExport = (data: any) =>
  request({
    url: '/manage/merchant-deposit-rank-export' + objToUrlParams(data),
    method: 'post'
  })

// 出金排名导出接口
export const getWithdrawRankExport = (data: any) =>
  request({
    url: '/manage/merchant-withdraw-rank-export' + objToUrlParams(data),
    method: 'post'
  })

// 商户余额导出接口
export const getMerchantBalanceExport = (data: any) =>
  request({
    url: '/manage/merchant-balance-export' + objToUrlParams(data),
    method: 'post'
  })
